import Axios from "axios";
import {
  bodyHeader,
  $observable,
} from "../../common/libs/AxiosObservable";

export const getContracts = () => {
  return $observable(Axios.get("api/v1/admin/contract-details?page=1&pageSize=10000"));
};

export const getContract = (id) => {
  return $observable(Axios.get(`api/v1/admin/contract-details/${id}`));
};

export const deleteContract = (id) => {
  return $observable(Axios.delete(`api/v1/admin/contracts/${id}`));
};

export const addContract = (obj) => {
  return $observable(
    Axios.post(`api/v1/admin/contracts`, JSON.stringify(obj), {
      headers: bodyHeader,
    })
  );
};

export const disableContract = ({ id }) => {
  return $observable(
    Axios.post(`api/v1/admin/contracts/${id}/disable`, {
      headers: bodyHeader,
    })
  );
};

export const setPayment = ({ id }) => {
  return $observable(
    Axios.post(`api/v1/admin/contracts/${id}/payment`, {
      headers: bodyHeader,
    })
  );
};

export const setUnPayment = ({ id }) => {
  return $observable(
    Axios.post(`api/v1/admin/contracts/${id}/un-payment`, {
      headers: bodyHeader,
    })
  );
};